import React from "react";

const TopBar = ({ isVisible }) => {
  return (
    <div
      className={`${
        isVisible ? "translate-y-0" : "-translate-y-full"
      } fixed top-0 left-0 w-full transition-transform duration-300 bg-gray-900 text-white py-2 px-3 text-sm flex justify-between items-center z-50`}
    >
      <a
        href="mailto:smkeventstudio@gmail.com"
        className="hover:text-textgold transition"
      >
        <b>smkeventstudio@gmail.com</b>
      </a>
      <a href="tel:+918883666618" className="hover:text-textgold transition">
        <b> +91 8883666618</b>
      </a>
    </div>
  );
};

export default TopBar;
